import React, {useState} from "react";
import {addNewCert} from "../../../../service/adminService";
import {Button, ButtonToolbar, Form, Modal} from "rsuite";
import {adminCertModel} from "../../../form/models";

const AddAdminCertModal = (props) => {
    const { open, handleClose } = props

    const [localState, setLocalState] = useState();

    const submitAdminCertAdd = (isFormValid) => {
        if(!isFormValid) return;
        addNewCert(localState).then((response) => {
            handleClose(response);
        });
    };

    // rsuite does not have an onSubmit, we must handle state changes per controlled field
    const handleFormChange = (event) => {
        setLocalState({...localState, ...event});
    }

    return (
        <Modal
            open={open}
            onClose={handleClose}
            backdrop="static"
            size="md"
        >
            <Modal.Header>
                <Modal.Title>Add Certificate</Modal.Title>
            </Modal.Header>
            <Modal.Body>
            </Modal.Body>
            <Form
                layout="horizontal"
                model={adminCertModel}
                onChange={handleFormChange}
                onSubmit={submitAdminCertAdd}
            >
                <Form.Group>
                    <Form.ControlLabel>Cert Name</Form.ControlLabel>
                    <Form.Control
                        name="certName"
                        style={{width: 500}}
                    />
                </Form.Group>
                <Form.Group>
                    <ButtonToolbar>
                        <Button type="submit" appearance="primary">
                            Ok
                        </Button>
                        <Button onClick={handleClose} appearance="default">
                            Cancel
                        </Button>
                    </ButtonToolbar>
                </Form.Group>
            </Form>
        </Modal>
    );
};

export default AddAdminCertModal;